import React from 'react';

import { AuthUserContext } from '../Session';
import { PasswordForgetForm } from '../PasswordForget';
import PasswordChangeForm from '../PasswordChange';
import { withAuthorization } from '../Session';
import style from '../../constants/accountStyle'

const AccountPage = () => (
  <AuthUserContext.Consumer>
    {authUser => (
      <div style={style.div}>
        <h1 style={style.h1}>Account: {authUser.email}</h1>
        <PasswordForgetForm styles={style}/>
        <PasswordChangeForm styles={style}/>
      </div>
    )}
  </AuthUserContext.Consumer>
);

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(AccountPage);
